import { targetBlank, isLocalUrl, isMobileBreakpoint } from '../utils';

export default function cardWidget14() {
  const widgetName = 'cardWidget14';
  const widgetOpts = cardWidget14Opts;
  const $widget = $(`#${widgetName}`);
  const wrapContainerClass = 'cardWidget14-container-wrapper';

  // you can remove this and import the validateWindowSize auxiliary function under Helpers/helpers.js
  const isDesktopScreen = !isMobileBreakpoint;

  // Label for buttons
  const moreLabel = 'More';
  const buyLabel = 'Buy Now';

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: isDesktopScreen ? [] : ['all'],
    showDescription: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 8,
    itemsPerPanel: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        $widget.wrap(
          `<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`,
        );
        createCustomCards(data.items);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.image-container').append('<div class="overlay"></div>');
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, Description, URL, PurchaseURL } = widgetData[x];
      const $cardItem = $(this);

      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
            <div class="hover-content">
            </div>
          </div>`);
      updateCardButtons($cardItem, URL, PurchaseURL);

      $cardItem.removeClass('void-link');
      validateContent($cardItem, URL, PurchaseURL, Description);
    });
  }

  // function to create buttons
  function updateCardButtons($item, btn1, btn2) {
    const newTabMore = targetBlank(btn1);
    const newTabBuy = targetBlank(btn2);

    $item.find('.hover-content').append(btn1 || btn2 ? `<div class="widget-button-wrapper">` : '');
    $item
      .find('.widget-button-wrapper')
      .append(btn1 ? `<a href="${btn1}" class="button" ${newTabMore} >${moreLabel}</a>` : '');
    $item
      .find('.widget-button-wrapper')
      .append(btn2 ? `<a href="${btn2}" class="button" ${newTabBuy}>${buyLabel}</a>` : '');
  }

  // ------------------------
  // validate content and custom elements
  function validateContent($item, btn1, btn2) {
    if (!btn1 && !btn2) {
      customItemsValidation($item, 'empty-card');
      attrUpdate($item);
      return;
    }

    if (btn2) {
      customItemsValidation($item, 'btn-2');
      attrUpdate($item, btn2);
      return;
    }

    if (btn1) {
      customItemsValidation($item, 'btn-1');
      attrUpdate($item, btn1);
    }
  }

  // function to add custom class
  function customItemsValidation($itemSelected, classStatus) {
    $itemSelected.addClass(classStatus);
  }

  // function to update attribute
  function attrUpdate($itemSelected, attribute) {
    if (!isDesktopScreen) {
      if (attribute) {
        $itemSelected.removeAttr('target');
        $itemSelected.attr('href', attribute);

        if (isLocalUrl(attribute)) {
          return;
        } else {
          $itemSelected.attr('target', '_blank');
        }
      } else {
        $itemSelected.removeAttr('href');
      }
    }
  }
}
